<template>
  <div class="nine-page flex-column justify-between align-center">
    <!-- <page-white-background title="初中中级体验词库" router-type="modal"> -->
    <div
      id="scroll-wrap-Nine"
      style="overflow-y: auto; overflow-x: hidden; height: 100%"
      :class="{ 'scroll-disabled': !canScroll() }"
      @scroll="ionScroll($event)"
      @wheel="preventScroll"
      @touchmove="preventScroll"
    >
      <ion-header class="ion-no-border">
        <div class="navbar flex-row align-center justify-between">
          <div class="nav-icon"></div>
          <span>单词识记</span>
          <img
            class="nav-icon cursor-pointer"
            :src="getBrandImageUrl('close_icon.png')"
            alt=""
            @click="onCloseModel"
          />
        </div>
      </ion-header>
      <div class="flex-column align-center">
        <div class="nine-square">
          <img class="nine-square_bg" src="@/assets/student/version5/nine_circle_bg.svg" alt="" />
          <img class="nine-circle1" src="@/assets/teacher_index/version5/nine_circle1.svg" alt="" />
          <img class="nine-circle2" src="@/assets/teacher_index/version5/nine_circle2.svg" alt="" />
          <img class="nine-circle3" src="@/assets/teacher_index/version5/nine_circle3.svg" alt="" />
          <img class="nine-circle4" src="@/assets/teacher_index/version5/nine_circle4.svg" alt="" />
          <img class="nine-circle5" src="@/assets/teacher_index/version5/nine_circle5.svg" alt="" />
          <img class="nine-circle6" src="@/assets/teacher_index/version5/nine_circle6.svg" alt="" />
          <img class="nine-circle7" src="@/assets/teacher_index/version5/nine_circle7.svg" alt="" />
          <img class="nine-circle8" src="@/assets/teacher_index/version5/nine_circle8.svg" alt="" />
          <img
            class="circle-center"
            src="@/assets/teacher_index/version5/nine_circle_center.svg"
            alt=""
            @click="openBeforeTest()"
          />
          <div class="circle-text text1 red-circle" @click="onMastery(step1, 1)">{{ step1 }}</div>
          <div class="circle-text text2 red-orange-circle" @click="onMastery(step2, 2)">
            {{ step2 }}
          </div>
          <div class="circle-text text3 orange-circle" @click="onMastery(step3, 3)">
            {{ step3 }}
          </div>
          <div class="circle-text text4 orange-circle" @click="onMastery(step4, 4)">
            {{ step4 }}
          </div>
          <div class="circle-text text5 yellow-circle" @click="onMastery(step5, 5)">
            {{ step5 }}
          </div>
          <div class="circle-text text6 yellow-circle" @click="onMastery(step6, 6)">
            {{ step6 }}
          </div>
          <div class="circle-text text7 yellow-circle" @click="onMastery(step7, 7)">
            {{ step7 }}
          </div>
          <div class="circle-text text8 green-circle" @click="onMastery(step8, 8)">{{ step8 }}</div>
        </div>
        <div class="drawers">
          <img class="drawers_bg" src="@/assets/student/version5/drawers_bg.svg" alt="" />
          <div class="drawers-content flex-column justify-between">
            <div class="drawers-content_course flex-row align-center justify-between">
              <img class="book" src="@/assets/teacher_index/version5/sign_book_icon.svg" alt="" />
              <div class="course-info flex-column justify-between">
                <div class="course-info_user flex-row align-center">
                  <div class="student-name">{{ studentName }}</div>
                  <img class="time-img" :src="statusObj[classTimeType]" alt="" />
                </div>
                <div class="course-name flex-row align-center" @click="showCourseSelect()">
                  <div class="course-name_text text-overflow-ellipsis">
                    {{ courseName }}
                  </div>
                  <div class="triangle"></div>
                </div>
                <!--              <div class="drawers-content_progress">
                <ion-progress-bar class="bar" :value="progressValue"></ion-progress-bar>
              </div>
              <div class="finished flex-row align-center justify-between">
                <span>已完成 {{ ((totalNum || 0) / 1500).toFixed(2) }}%</span>
                <span>{{ totalNum || 0 }}/1500词</span>
              </div>-->
              </div>
            </div>
            <div class="drawers-content_divider"></div>
            <div v-if="classScope" class="drawers-content_time flex-row align-center">
              <img
                class="drawers-content_book"
                src="@/assets/teacher_index/version5/nine_clock.svg"
                alt=""
              />
              <span>训练时间：{{ classScope }}</span>
            </div>
            <div class="drawers-content_statistic flex-row justify-around align-center">
              <div>
                <div class="num">{{ learnNum || 0 }}</div>
                <span class="label">今日识词(个)</span>
              </div>
              <div class="divider"></div>
              <div>
                <div class="num">{{ reviewNum || 0 }}</div>
                <span class="label">今日待复习(个)</span>
              </div>
              <div class="divider"></div>
              <div>
                <div class="num">{{ totalNum || 0 }}</div>
                <span class="label">累计识词</span>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons flex-row justify-around">
          <ion-button class="buttons-button orange" shape="round" @click="onContinue"
            >继续练习
          </ion-button>
          <ion-button class="buttons-button linear-green" shape="round" @click="clickReviewButton"
            >开始复习
          </ion-button>
        </div>
      </div>
      <div class="bottom-logo">
        <!--      <img src="@/assets/student/version5/bottom_logo.svg" alt="" />-->
      </div>
    </div>

    <!-- </page-white-background> -->
  </div>
</template>

<script>
import { actionSheetController, IonButton, IonHeader, modalController } from "@ionic/vue"
import pagesQueue from "@/js/pagesQueue"
import mqttServer from "@/js/mqtt"
import { caretDown, library } from "ionicons/icons"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import { debounce } from "lodash"
import Time30 from "@/assets/teacher_index/version5/time_30.svg"
import Time60 from "@/assets/teacher_index/version5/time_60.svg"
import TimeExperience from "@/assets/teacher_index/version5/time_exper.svg"

export default {
  name: "SpeedReview",
  components: {
    IonHeader,
    IonButton,
  },
  props: ["studentId", "readingId"],
  setup() {
    return {
      library,
      caretDown,
    }
  },
  data() {
    return {
      beforeFlag: false,
      courseId: undefined,
      courseName: undefined,
      reviewNum: 0,
      learnNum: 0,
      totalNum: 0,
      currentNum: 0,
      step1: 0,
      step2: 0,
      step3: 0,
      step4: 0,
      step5: 0,
      step6: 0,
      step7: 0,
      step8: 0,

      //################################
      buttons: [],
      brandImages: BRAND_IMAGES,
      studentName: "", // 学生姓名
      classTimeType: "", // 练习类型 30分钟 | 60分钟 | 体验课
      classScope: "", // 练习时间的范围
      startTime: "",
      endTime: "",
      progressValue: 0.3,
      statusObj: {
        1: Time30,
        2: Time60,
        3: TimeExperience,
        4: "",
      },
      time: null, //滚动防抖
      debouncedScrollHandler: null, // 防抖滚动处理函数
      debouncedActionScrollHandler: null, // 防抖Action滚动处理函数
      canScrollPermission: true, // 添加响应式的滚动权限状态
      instructData: {
        //信令传递参数
        project: "lxll",
        page: "teachIndex",
        pageModle: true,

        module: "Nine",
        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      beforeTestModal: null,
      reviewModal: null,
      signModal: null,
    }
  },
  watch: {
    beforeTestModal() {
      if (this.beforeTestModal) {
        this.listenBeforeModalDismiss()
      }
    },
    reviewModal() {
      if (this.reviewModal) {
        this.listenReviewModalDismiss()
      }
    },
    signModal() {
      if (this.signModal) {
        this.listenSignModalDismiss()
      }
    },
  },

  beforeUnmount() {
    // 清理防抖函数
    if (this.debouncedScrollHandler) {
      this.debouncedScrollHandler.cancel()
    }
    if (this.debouncedActionScrollHandler) {
      this.debouncedActionScrollHandler.cancel()
    }
    // 移除权限变化监听器
    mqttServer.removePermissionListener(this.updateScrollPermission)
  },

  mounted() {
    // sessionStorage.setItem('pageFlag','false')
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)

    // 初始化滚动权限状态
    this.updateScrollPermission()

    // 添加权限变化监听器
    mqttServer.addPermissionListener(this.updateScrollPermission)

    // 初始化防抖滚动处理函数
    this.debouncedScrollHandler = debounce((e) => {
      // 只有有滚动权限的用户才能发送滚动消息
      if (this.canScroll()) {
        mqttServer.pushMsg(this.instructData, {
          params: [JSON.parse(JSON.stringify(e.target.scrollTop))],
          fn: "handleScroll",
          msgType: "function",
          udp: true,
        })
      }
    }, 600)

    // 初始化防抖Action滚动处理函数
    this.debouncedActionScrollHandler = debounce((e) => {
      mqttServer.pushMsg(this.instructData, {
        params: [JSON.parse(JSON.stringify(e.target.scrollTop))],
        fn: "handleScrollEventAction",
        msgType: "function",
        udp: true,
      })
    }, 300)

    this.queryMyCourseList()
    this.getAudioPath() //获取音频文件路径
    this.initNineStudentInfo()
    this.learningInfo()
    // setTimeout(() => {
    //   this.learningInfo()
    // }, 500)
  },
  methods: {
    // 检查当前用户是否有发送权限（即是否有滚动权限）
    canScroll() {
      const appointment = this.store.getAppointment()
      // 如果是巡查官，总是可以滚动,或者不是视频课，也能滚动
      if ((this.userinfo && this.userinfo.isAdmin) || appointment.videoFlag != 1) {
        return true
      }
      // 使用响应式的权限状态
      return this.canScrollPermission
    },

    // 更新滚动权限状态
    updateScrollPermission() {
      this.canScrollPermission = mqttServer.getCanSend()
    },

    // 阻止滚动事件
    preventScroll(e) {
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },

    // 滚动事件监听
    ionScroll(e) {
      // 检查是否有滚动权限
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
      // 使用 lodash debounce 替代 setTimeout
      this.debouncedScrollHandler(e)
    },

    //处理滚动事件
    handleScroll(e) {
      let dom = document.getElementById("scroll-wrap-Nine")
      // let domHeight = document.getElementById('scroll-wrap-article').clientHeight
      // let scrollHeight = e * domHeight
      dom.scrollTop = e
    },

    // 关闭九阶岛
    onCloseModel() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "onCloseModelSync",
          msgType: "function",
        })
        .then((res) => {
          console.log(res)
          this.onCloseModelSync()
        })
    },
    onCloseModelSync() {
      console.log("7777777")
      pagesQueue.queuePagePop()

      modalController.dismiss()
    },
    getBrandImageUrl,

    //取消点击资料列表
    cancleActionModel() {
      let dom = document.getElementsByClassName("action-sheet-group")[0]
      if (dom) {
        dom.removeEventListener("scroll", this.handleActionScroll)
      }
      actionSheetController.dismiss()
    },

    async showCourseSelectSync() {
      if (this.buttons.length == 0) {
        this.buttons.push({
          text: "取消",
          role: "cancel",
          handler: () => {
            mqttServer
              .pushMsg(this.instructData, {
                fn: "cancleActionModel",
                msgType: "function",
              })
              .then(() => {
                this.cancleActionModel()
              })
          },
        })
      }
      const actionSheet = await actionSheetController.create({
        header: "选择资料",
        cssClass: "myActionSheet courseSheet",
        backdropDismiss: false,
        buttons: this.buttons,
      })

      setTimeout(() => {
        let dom = document.getElementsByClassName("action-sheet-group")[0]
        console.log(dom)
        dom.addEventListener("scroll", this.handleActionScroll)
      }, 1000)

      await actionSheet.present()
    },

    handleScrollEventAction(e) {
      let dom = document.getElementsByClassName("action-sheet-group")[0]
      if (!dom) return
      dom.scrollTop = e
    },

    handleActionScroll(e) {
      // 使用 lodash debounce 替代直接调用
      this.debouncedActionScrollHandler(e)
    },

    //显示选择资料列表
    async showCourseSelect() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "showCourseSelectSync",
          msgType: "function",
        })
        .then(async () => {
          this.showCourseSelectSync()
        })
    },

    learningInfo() {
      console.log("leaning1")
      this.ajax.get("/vocabulary/learningInfo?studentId=" + this.studentId).then((res) => {
        this.courseId = res.data.courseId
        this.courseName = res.data.courseName
        this.reviewNum = res.data.reviewNum
        this.learnNum = res.data.learnNum
        this.totalNum = res.data.totalNum
        this.currentNum = res.data.currentNum
        this.step1 = res.data.step1
        this.step2 = res.data.step2
        this.step3 = res.data.step3
        this.step4 = res.data.step4
        this.step5 = res.data.step5
        this.step6 = res.data.step6
        this.step7 = res.data.step7
        this.step8 = res.data.step8

        this.appointment = this.store.getAppointment()
        this.appointment.courseId = this.courseId
        this.store.setAppointment(this.appointment)
      })
    },

    //学新异步
    async openBeforeTestSync() {
      this.ajax
        .get(
          "/vocabulary/countNotInPersonal?studentId=" +
            this.studentId +
            "&courseId=" +
            this.courseId
        )
        .then(async (res) => {
          if (res.data.success) {
            if (res.data.count > 0) {
              pagesQueue.queuePagePush({
                page: "BeforeTest",
                params: { studentId: this.studentId },
              })
              // const modal = await modalController.create({
              //   component: BeforeTest,
              //   componentProps: { studentId: this.studentId },
              //   cssClass: "modal_controller_class modal_controller_classBeforeTest",
              // })
              this.beforeFlag = false

              // await modal.present()
              // const { data } = await modal.onDidDismiss()
              // console.log("nine1", data)
              // if (data) {
              //   if (data.status === "TO_ARTICLE" || data.status === "TO_ARTICLE") {
              //     await modalController.dismiss({ ...data })
              //   } else {
              //     this.learningInfo()
              //   }
              // }
            } else {
              this.alert(this.$t("本词库已学完，请复习或选其他词库练习！"))
            }
          }
        })
        .finally(() => {
          this.beforeFlag = false
          sessionStorage.setItem("pageFlag", "false")
        })
    },

    //学新
    async openBeforeTest() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "openBeforeTestSync",
          msgType: "function",
        })
        .then(() => {
          this.openBeforeTestSync()
        })
    },

    async listenBeforeModalDismiss() {
      await this.beforeTestModal.onDidDismiss()
      //如果是从阅读理解打开的此页面，则学完单词以后直接回到阅读理解。
      if (this.readingId) {
        await modalController.dismiss()
      } else {
        this.learningInfo()
      }
    },

    //复习
    async openReview(mastery) {
      sessionStorage.setItem("pageFlag", "false")

      pagesQueue.queuePagePush({
        page: "Review",
        params: { studentId: this.studentId, mastery: mastery },
      })
      // const modal = await modalController.create({
      //   component: Review,
      //   componentProps: { studentId: this.studentId, mastery: mastery },
      //   cssClass: "modal_controller_class modal_controller_classReview",
      // })
      // await modal.present()
      // const { data } = await modal.onDidDismiss()
      // console.log("review", data)
      // if (data) {
      //   if (data.status === "TO_ARTICLE") {
      //     await modalController.dismiss({ ...data })
      //   } else {
      //     this.learningInfo()
      //   }
      // } else {
      //   this.learningInfo()
      // }
    },

    async listenReviewModalDismiss() {
      await this.reviewModal.onDidDismiss()
      this.learningInfo()
    },

    //
    async openSignSync() {
      sessionStorage.setItem("pageFlag", "false")

      pagesQueue.queuePagePush({
        page: "Sign",
        params: { studentId: this.studentId },
      })
      // const modal = await modalController.create({
      //   component: Sign,
      //   componentProps: { studentId: this.studentId },
      //   cssClass: "modal_controller_class",
      // })

      // await modal.present()
      // const { data } = await modal.onDidDismiss()
      // if (data) {
      //   if (data.status === "TO_ARTICLE") {
      //     await modalController.dismiss({ ...data })
      //   }
      // }
    },

    async openSign() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "openSignSync",
          msgType: "function",
        })
        .then(async () => {
          this.openSignSync()
        })
      // const modal = await modalController.create({
      //   component: Sign,
      //   componentProps: { studentId: this.studentId },
      //   cssClass: "modal_controller_class",
      // });

      // await modal.present();
      // const { data } = await modal.onDidDismiss();
      // if (data) {
      //   if (data.status === "TO_ARTICLE") {
      //     await modalController.dismiss({ ...data });
      //   }
      // }
    },

    //打开复习页面
    clickReviewButtonSync() {
      this.openReview(0)
    },

    //打开复习页面
    clickReviewButton() {
      mqttServer
        .pushMsg(this.instructData, {
          fn: "clickReviewButtonSync",
          msgType: "function",
        })
        .then(() => {
          this.openReview(0)
        })
    },

    //继续练习
    onContinue() {
      if (this.currentNum > 0) {
        this.openSign()
      } else {
        this.openBeforeTest()
      }
    },

    onMasterySync(num, mastery) {
      if (num && num > 0) {
        // sessionStorage.setItem('pageFlag', 'false')

        this.openReview(mastery)
      }
    },

    //打开九阶岛对应的每一级页面
    onMastery(num, mastery) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [num, mastery],
          fn: "onMasterySync",
          msgType: "function",
        })
        .then(() => {
          this.onMasterySync(num, mastery)
        })
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 200)
      this.dataList = []
      this.learningInfo()
      this.queryMyCourseList()
    },

    //处理点击资料列表
    handleActionCloum(item, param) {
      actionSheetController.dismiss()
      let dom = document.getElementsByClassName("action-sheet-group")[0]
      console.log(dom)
      if (dom) {
        dom.removeEventListener("scroll", this.handleActionScroll)
      }
      const roomConfig = sessionStorage.getItem("roomConfig") || ""
      if (roomConfig != "" && JSON.parse(roomConfig).roomId) {
        param.videoFlag = 1
      }
      this.ajax.post("/course/changeCourse", param).then((res1) => {
        if (res1.data.success) {
          this.courseName = res1.data.courseName
          this.courseId = res1.data.courseId
          this.courseName = res1.data.courseName
          this.reviewNum = res1.data.reviewNum
          this.learnNum = res1.data.learnNum
          this.totalNum = res1.data.totalNum
          this.currentNum = res1.data.currentNum
          this.step1 = res1.data.step1
          this.step2 = res1.data.step2
          this.step3 = res1.data.step3
          this.step4 = res1.data.step4
          this.step5 = res1.data.step5
          this.step6 = res1.data.step6
          this.step7 = res1.data.step7
          this.step8 = res1.data.step8
          let obj = this.store.getAppointment()
          obj = {
            ...obj,
            ...param,
          }
          this.store.setAppointment(obj)
        }
        // this.learningInfo()
      })
    },

    //
    queryMyCourseList() {
      const that = this
      const studentId = this.store.getStudentId()
      const appointment = this.store.getAppointment()
      let trial = true

      if (appointment != null) {
        trial = appointment.classification == 3
      }

      this.ajax
        .get("/course/queryMyCourseList?studentId=" + studentId + "&trial=" + trial)
        .then((res) => {
          if (res.data.success) {
            if (res.data.list) {
              that.buttons = []
              res.data.list.forEach((item) => {
                let strTitle = ""
                if (item.finished) {
                  strTitle = item.courseName + "   (已训完)"
                }

                //显示学新数量
                else {
                  if (item.learnNewNumber) {
                    strTitle = item.courseName + "  " + item.learnNewNumber + "/" + item.number
                  } else {
                    strTitle = item.courseName
                  }
                }

                const param = {
                  studentId: studentId,
                  courseId: item.courseId,
                  aptmId: appointment.aptmId,
                  schoolId: appointment.schoolId,
                  courseName: item.courseName,
                }

                let showButton = false

                //体验课
                if (appointment.classification == 3) {
                  showButton = true
                }

                //其它资料类型
                //如果是阅读课，则限制词库范围
                else if (
                  (appointment.courseTypeId == 3 && item.courseTypeId == 3) ||
                  (appointment.courseTypeId == 1 && item.courseTypeId == 1)
                ) {
                  showButton = true
                }

                if (showButton) {
                  // mqttServer
                  //       .pushMsg(this.instructData, {
                  //         params: [item, param],
                  //         fn: "handleActionCloum",
                  //         msgType: "function",
                  //       })
                  //       .then(() => {
                  that.buttons.push({
                    text: strTitle,
                    handler: () => {
                      mqttServer
                        .pushMsg(this.instructData, {
                          params: [item, param],
                          fn: "handleActionCloum",
                          msgType: "function",
                        })
                        .then(() => {
                          this.handleActionCloum(item, param)
                        })
                    },
                  })
                }
              })
            }

            that.buttons.push({
              text: "取消",
              role: "cancel",
              handler: () => {
                mqttServer
                  .pushMsg(this.instructData, {
                    fn: "cancleActionModel",
                    msgType: "function",
                  })
                  .then(() => {
                    this.cancleActionModel()
                  })
              },
            })
            sessionStorage.setItem("pageFlag", "true")
          }
        })
    },

    //获取音频文件路径
    getAudioPath() {
      this.ajax.get("/config/getConfig?key=AUDIO_INNER_PATH").then((res) => {
        if (res.data.success) {
          this.setAudioInnerPath(res.data.data)
        }
      })
    },

    initNineStudentInfo() {
      // 资料类型 3 体验课 2 60分钟 1 30分钟
      let studentInfo = this.store.getAppointment()
      if (studentInfo.aptmId == 0) {
        studentInfo = this.store.getUser()
      }
      this.studentName = studentInfo.studentName || studentInfo.username
      this.classTimeType = studentInfo.classification || ""
      if (studentInfo.startTime && studentInfo.endTime) {
        this.classScope = studentInfo.startTime + "-" + studentInfo.endTime
      } else {
        this.classScope = null
      }
      this.startTime = studentInfo.startTime
      this.endTime = studentInfo.endTime
    },
    //处理接收到的消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.nine-page {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: linear-gradient(180deg, #dcf8ef 0%, #f2f3f7 30%);

  #scroll-wrap-Nine {
    &.scroll-disabled {
      overflow: hidden;
      pointer-events: none;
    }
  }

  .navbar {
    width: 100%;
    height: 5rem;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: 600;
    padding: 0 1rem;

    .nav-icon {
      width: 1.2rem;
    }
  }

  .nine-square {
    width: 21rem;
    height: 21rem;
    position: relative;

    &_bg {
      width: 100%;
      position: relative;
      z-index: 1;
    }

    .nine-circle1 {
      position: absolute;
      left: 16%;
      top: 64%;
      width: 5.1rem;
      z-index: 2;
    }

    .nine-circle2 {
      position: absolute;
      left: 8%;
      top: 46%;
      width: 4.7rem;
      z-index: 2;
    }

    .nine-circle3 {
      position: absolute;
      left: 10%;
      top: 20%;
      width: 5.1rem;
      z-index: 2;
    }

    .nine-circle4 {
      position: absolute;
      left: 26%;
      top: 8%;
      width: 5.3rem;
      z-index: 2;
    }

    .nine-circle5 {
      position: absolute;
      left: 54%;
      top: 9%;
      width: 4.8rem;
      z-index: 2;
    }

    .nine-circle6 {
      position: absolute;
      left: 66%;
      top: 21%;
      width: 5.4rem;
      z-index: 2;
    }

    .nine-circle7 {
      position: absolute;
      left: 70%;
      top: 46%;
      width: 4.6rem;
      z-index: 2;
    }

    .nine-circle8 {
      position: absolute;
      left: 60%;
      top: 63%;
      width: 5.2rem;
      z-index: 2;
    }

    .circle-center {
      position: absolute;
      left: 33.5%;
      top: 35%;
      width: 7rem;
      z-index: 2;
    }

    .circle-text {
      color: #ffffff;
      width: 2.8rem;
      height: 2.8rem;
      border-radius: 50%;
      text-align: center;
      line-height: 2.8rem;
      box-shadow: 0 2px 10px 0 #91512233 inset;
    }

    .red-circle {
      background: linear-gradient(0deg, #f45d54, #f45d54),
        linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));
    }

    .red-orange-circle {
      background: linear-gradient(0deg, #f78635, #f78635),
        linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));
    }

    .orange-circle {
      background: linear-gradient(0deg, #f39f30, #f39f30),
        linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));
    }

    .yellow-circle {
      background: linear-gradient(0deg, #f7cd32, #f7cd32),
        linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));
    }

    .green-circle {
      background: linear-gradient(0deg, #88e143, #88e143),
        linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04));
    }

    .text1 {
      position: absolute;
      left: 21.5%;
      top: 68%;
      z-index: 3;
    }

    .text2 {
      position: absolute;
      left: 11.5%;
      top: 49%;
      z-index: 3;
    }

    .text3 {
      position: absolute;
      left: 16.5%;
      top: 26%;
      z-index: 3;
    }

    .text4 {
      position: absolute;
      left: 34.5%;
      top: 13%;
      z-index: 3;
    }

    .text5 {
      position: absolute;
      left: 57%;
      top: 15%;
      z-index: 3;
    }

    .text6 {
      position: absolute;
      left: 72%;
      top: 30%;
      z-index: 3;
    }

    .text7 {
      position: absolute;
      left: 75%;
      top: 51%;
      z-index: 3;
    }

    .text8 {
      position: absolute;
      left: 63%;
      top: 68%;
      z-index: 3;
    }
  }

  .drawers {
    width: 24rem;
    margin: 2rem 0;
    position: relative;
    z-index: 1;
    display: flex;

    &_bg {
      width: 100%;
    }

    &-content {
      flex: 1;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      padding: 2rem 0.6rem 1rem;

      &_progress {
        width: 100%;
      }

      &_divider {
        width: 100%;
        height: 1px;
        border-radius: 1px;
        background-color: rgba(234, 234, 234, 0.8);
        margin: 1rem 0;
      }

      &_course {
        .book {
          width: 2.8rem;
          margin-right: 1rem;
        }

        .course-info {
          flex: 1;
          width: 100%;
          height: 90%;

          &_user {
            font-size: 1.1rem;
            font-weight: 600;

            .student-name {
              width: 62%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            img {
              height: 1.4rem;
              margin-left: 0.5rem;
            }
          }

          .course-name {
            color: #1e2023;
            font-size: 1.1rem;
            font-weight: 600;

            &_text {
              max-width: 18rem;
              font-weight: 400;
              color: #3f4140;
              font-size: 0.8rem;
            }

            .triangle {
              width: 0.5rem;
              margin-left: 0.5rem;

              &::after {
                content: "";
                display: inline-block;
                width: 0;
                height: 0;
                border-top: 0.2rem solid transparent;
                border-bottom: 0.2rem solid #1e2023;
                border-right: 0.2rem solid #1e2023;
                border-left: 0.2rem solid transparent;
              }
            }
          }
        }

        .finished {
          color: #676767;
          font-size: 0.8rem;
        }
      }

      //&_progress {
      //  margin: 0.5rem 0;
      //  .bar {
      //    border-radius: 0.5rem;
      //    &::part(progress) {
      //      background: #2bca9c;
      //    }
      //    &::part(track) {
      //      background: #e9e7e7;
      //    }
      //  }
      //}
      &_time {
        color: #676767;
        font-size: 0.9rem;
        margin-bottom: 1.8rem;

        img {
          width: 1rem;
          margin-right: 0.3rem;
        }
      }

      &_statistic {
        text-align: center;

        .divider {
          width: 1px;
          height: 2rem;
          background: #e2e6e9;
        }

        .num {
          color: #1e2023;
          font-size: 1.2rem;
        }

        .label {
          color: #9a9b9c;
          font-size: 0.85rem;
        }
      }
    }
  }

  .buttons {
    width: 25rem;

    &-button {
      width: 45%;
      height: 3rem;
      font-size: 1rem;
      --box-shadow: none;
    }

    .orange {
      --background: #ffad00;
      color: #3f4140;
    }

    .linear-green {
      --background: linear-gradient(90deg, #00c67c 0%, #01edb2 100%);
    }
  }

  .bottom-logo {
    width: 70%;
    height: 3rem;

    img {
      width: 100%;
    }
  }

  &_page {
    width: 100%;
    height: 100%;
  }

  &_card {
    box-shadow: 0 0 1px 0 var(--mark-border-color);
    padding: 4vw 3vw;

    .user-name {
      font-size: var(--font-3);
    }

    .class-type {
      height: 3.5vw;
    }

    .nine-avatar {
      width: 10vw;
      object-fit: contain;
    }

    .nine-info {
      width: 100%;
    }

    .text {
      color: var(--font-black-color);
    }

    .class-time {
      color: var(--font-deep-gray);
      padding-bottom: 3vw;
      margin-bottom: 3vw;

      img {
        margin-bottom: 0.3vh;
      }
    }

    .class-statistic {
      border-top: 1px solid var(--border-color-1);
      padding-top: 3vw;

      & > div {
        text-align: center;
        color: var(--font-deep-gray);
      }

      .num {
        font-size: var(--font-5);
        font-weight: 600;
        line-height: 2.5rem;
        color: var(--font-black-color);
      }
    }
  }

  .dashboard {
    position: relative;
    width: 90%;
    margin: 0 auto;

    &_image {
      position: relative;
      width: 100%;
      z-index: 4;
    }

    &_content {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50%;
    }

    &_button {
      position: absolute;
      left: 50%;
      bottom: 60%;
      width: 20%;
      z-index: 5;
      transform: translate(-50%, -50%);
    }

    &_block {
      width: 100%;
      height: 100%;

      .white-block {
        position: absolute;
        left: 0;
        bottom: 7%;
        width: 100%;
        z-index: 5;
      }

      .pointer {
        position: absolute;
        left: 0;
        top: -98%;
        width: 100%;
        transform: rotate(24deg);
        z-index: 3;
      }

      .line {
        position: absolute;
        left: 0;
        bottom: 73%;
        width: 100%;
        z-index: 6;
      }

      .block-left {
        position: absolute;
        left: 2%;
        bottom: 85%;
        width: 20%;
        z-index: 4;
      }

      .block-right {
        position: absolute;
        right: 2%;
        bottom: 85%;
        width: 20%;
        z-index: 4;
      }

      .button {
        position: absolute;
        left: 12%;
        bottom: 48%;
        width: 50%;
        z-index: 7;
        white-space: nowrap;
        //font-weight: 600;

        img {
          width: 20%;
          margin-left: 5%;
        }
      }

      .continue-button {
        left: 12%;
      }

      .start-button {
        left: 69%;
      }
    }
  }
}
</style>
